if (!customElements.get('back-in-stock')) {
  customElements.define(
    'back-in-stock',
    // eslint-disable-next-line no-undef
    class BackInStock extends window.BAO.CustomElement() {
      constructor () {
        super()

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.QUICKBUY.AFTER_OPTIONS_LOAD,
          () => {
            const triggerEls = window.BAO.utils.getElements(
              this.triggerSelector,
            )
            this.externalEls = {
              ...this.externalEls,
              trigger: {
                exists: triggerEls.length > 0,
                elements: triggerEls,
                element: triggerEls[0],
                selector: this.triggerSelector,
              },
            }

            this.disconnectedCallback()
            this.setupListeners()
          },
        )

        this.submitEl = this.getEl('trigger')
      }

      setupListeners () {
        super.setupListeners()

        if (this.hasExternalEl('trigger')) {
          this.getExternalEls('trigger').forEach(triggerEl => {
            this.listeners.add(
              triggerEl,
              'click',
              this.handleTriggerClick.bind(this),
            )
          })
        }

        if (!this.hasEl('form')) return
        this.listeners.add(
          this.getEl('form'),
          'submit',
          this.handleSubmit.bind(this),
        )

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.MOBILE_QUICK_BUY.OPENED,
          this.additionalTriggerListeners.bind(this),
        )
      }

      additionalTriggerListeners () {
        setTimeout(() => {
          const extraTriggerEls = window.BAO.utils.getElements(
            this.mobileTriggerSelector,
          )

          if (extraTriggerEls.length > 0) {
            extraTriggerEls.forEach(triggerEl => {
              this.listeners.add(
                triggerEl,
                'click',
                this.handleTriggerClick.bind(this),
              )
            })
          }
        }, 500)
      }

      handleTriggerClick (event) {
        let triggerEl = false

        if (
          event.target.getAttribute('data-back-in-stock-external-el') ===
          'trigger'
        ) {
          triggerEl = event.target
        } else {
          triggerEl = event.target.closest(this.externalEls.trigger.selector)
        }
        if (!triggerEl) return

        this.productId = triggerEl.dataset.productId || null
        this.variantId = triggerEl.dataset.variantId || null
        this.productUrl = triggerEl.dataset.productUrl || null
        this.productPrice = triggerEl.dataset.productPrice || null

        if (this.submitEl) {
          this.submitEl.dataset.productId = this.productId
          this.submitEl.dataset.variantId = this.variantId
        }

        this.productImageUrl = window.BAO.utils
          .getElement(this.productImage)
          .getAttribute(`data-${this.productId}-product-image`)
      }

      async handleSubmit (event) {
        event.preventDefault()
        if (this.email.length < 1) return
        this.submitEl.setAttribute('disabled', true)
        this.sendBIS()
      }

      async sendBIS () {
        const mediumValue = this.email
        const medium = 'email'
        const topic = 'backinstock'
        const product = {
          epi: this.variantId,
          empi: this.productId,
          du: this.productUrl,
          iu: this.productImageUrl,
          pr: this.productPrice,
        }

        const onSuccess = response => {
          if (typeof response !== 'undefined') {
            this.handleResponse(response)
          }
        }

        const onError = error => {
          if (typeof response !== 'undefined') {
            this.handleResponse(error)
          }
        }

        window._swat.subscribeForProductAlert(
          mediumValue,
          medium,
          product,
          onSuccess,
          onError,
          0,
          topic,
        )
      }

      handleResponse (response) {
        const responseEl = this.getEl('response')

        if (!responseEl) return
        this.toggleResponse(false)
        if (
          response.message === 'Successfully added a Product alert for user'
        ) {
          responseEl.innerHTML = `<p>${this.dataset.successMessage}</p>`
        } else {
          responseEl.innerHTML = `<p>${this.dataset.errorMessage}</p>`
        }

        this.submitEl.removeAttribute('disabled')
        this.toggleResponse(true)
      }

      toggleResponse (isVisible) {
        this.getEl('response').setAttribute(
          'aria-hidden',
          (!isVisible).toString(),
        )
      }

      hasEl (elementName) {
        return this.els[elementName] && this.els[elementName].exists
      }

      hasExternalEl (elementName) {
        return (
          this.externalEls[elementName] && this.externalEls[elementName].exists
        )
      }

      getEl (elementName) {
        return this.hasEl(elementName) ? this.els[elementName].element : null
      }

      getExternalEl (elementName) {
        return this.hasExternalEl(elementName)
          ? this.externalEls[elementName].element
          : null
      }

      getEls (elementName) {
        return this.hasEl(elementName) ? this.els[elementName].elements : []
      }

      getExternalEls (elementName) {
        return this.hasExternalEl(elementName)
          ? this.externalEls[elementName].elements
          : []
      }

      get email () {
        const emailEl = this.getEl('email')
        return emailEl ? emailEl.value : ''
      }

      get productId () {
        return this._productId
      }

      set productId (productId) {
        this._productId = productId
      }

      get variantId () {
        return this._variantId
      }

      set variantId (variantId) {
        this._variantId = variantId
      }

      get triggerSelector () {
        return '[data-back-in-stock-external-el="trigger"]'
      }

      get mobileTriggerSelector () {
        return 'product-quick-buy-mobile [data-back-in-stock-external-el="trigger"]'
      }

      get productImage () {
        return `[data-${this.productId}-product-image]`
      }
    },
  )
}
